import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Button from '@propertypal/web-ui/src/buttons/Button';
import TextInput from '@propertypal/web-ui/src/inputs/TextInput';
import { Icon, Input } from '@propertypal/web-ui/src/inputs/TextInput.style';
import styled, { css } from 'styled-components';

export const Alert = styled.div`
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid ${({ theme }) => theme.lightGrey};
  padding: 16px;
  font-weight: 600;
  display: flex;
  width: 100%;
  text-align: left;
  gap: 8px;
  margin-bottom: 16px;
`;

export const AlertMessageContainer = styled.div`
  flex: 1 1 auto;
`;

export const AlertMessage = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SearchInput = styled(TextInput)`
  ${Input} {
    padding: 0 15px 0 40px;
  }
  ${Icon} {
    left: -10px;
    svg {
      color: ${({ theme }) => theme.textDark};
    }
  }
`;

export const MapContainer = styled.div`
  margin-top: 16px;
  width: 100%;
  height: 400px;
`;

export const Form = styled.form<{ $isSubmitting: boolean }>`
  margin-top: 16px;

  ${({ $isSubmitting }) =>
    $isSubmitting
      ? css`
          pointer-events: none;
          opacity: 0.5;
        `
      : ''}
`;

export const InputContainer = styled.div`
  margin-bottom: 16px;
`;

export const OptionsList = styled.div`
  overflow: auto;
  scroll-snap-type: x mandatory;
  -webkit-box-direction: normal;
  scrollbar-width: none;
`;

export const Options = styled.div`
  display: flex;
  margin: 5px 0 16px;
  gap: 10px;
  position: relative;

  @media (${tabletMax}) {
    &::after {
      display: block;
      content: '';
      position: absolute;
      right: 0px;
      width: 48px;
      height: 48px;
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 90%);
    }
  }
`;

export const OptionContainer = styled.div`
  scroll-snap-align: start;
  scroll-snap-stop: normal;
`;

export const Option = styled.button<{ $selected: boolean }>`
  min-width: 66px;
  border: 1px solid ${({ theme }) => theme.keyline};
  border-radius: 44px;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  overflow: hidden;
  min-height: 36px;
  background-color: ${({ theme, $selected }) => ($selected ? theme.primary : theme.background)};
  justify-content: center;
  align-items: center;
  justify-items: center;
  transition: background-color 150ms linear;
  color: ${({ theme, $selected }) => ($selected ? theme.white : theme.textDark)};

  span {
    min-height: 44px;
    line-height: 44px;
    white-space: nowrap;
    font-size: 16px;
  }

  svg,
  span {
    text-align: center;
    padding: 0 10px;
  }

  &:hover {
    background-color: ${({ theme, $selected }) => ($selected ? theme.primary : theme.lightGrey)};
  }
`;

export const SubmitButton = styled(Button)`
  width: 100%;
`;
